import ajax from "@/lib/ajax";
import { Message } from "element-ui";

const URLs = {
    UPDATE_BUSI: "/xiaoyue-operation/business/update", // 更新基本配置
    UPDATE_ROBO: "/xiaoyue-operation/business/updateRobots", // 更新机器人配置
    CREATE_ROBO: "/xiaoyue-operation/business/createRobots", // 创建机器人
    GET_BUSI: "/xiaoyue-operation/business/getRobotsInfo", // 获取整体信息
    GET_ROBOT: "/xiaoyue-operation/tenant/getOnlineTenantConfFromTestEnv" // 获取正式环境机器人
};

// 获取业务设置
export async function queryInfo() {
    let ret = null;
    try {
        const resp = await ajax.get(URLs.GET_BUSI, {});
        ret = {
            businessName: resp.business_name,
            languages: resp.langlist ? resp.langlist.split(",") : [],
            modules: resp.permit_code ? resp.permit_code.split(",") : [],
            robots: (resp.robot_info || []).map(rInfo => ({
                gameId: rInfo.game_id,
                robotName: rInfo.game_name,
                source: rInfo.answer_channel ? JSON.parse(rInfo.answer_channel) : [],
                defaultLang: rInfo.default_lang,
                isUpdate: true,
                robotOperationTime: resp.robot_operation_time,
                robotOperator: resp.robot_operator,
            })),
            editTime: resp.edit_time,
            editor: resp.editor,
            tipFormat: resp.tip_content_format
        };
    } catch (err) {
        console.error(err);
    }
    return ret;
}

// 设置基础数据
export async function updateBaseInfo(businessName, info) {
    const request = {
        business_name: businessName,
        langlist: info.languages.join(","),
        permit_code: info.modules.join(","),
        tip_content_format: info.tipFormat,
    };

    try {
        await ajax.post(URLs.UPDATE_BUSI, request);
        Message.success({
            title: "成功",
            message: "操作成功"
        });
    } catch (err) {
        console.error(err);
    }
}

// 设置机器人数据
export async function updateRobot(robots) {
    const serverRobots = robots.map(rInfo => ({
        game_id: rInfo.gameId || "",
        robot_name: rInfo.robotName,
        channel: rInfo.source,
        default_lang: rInfo.defaultLang,
        isUpdate: rInfo.isUpdate
    }));

    // 根据是否有game_id判断是更新还是新增
    const updateRobots = serverRobots
        .filter(r => !!r.game_id && r.isUpdate)
        .map(r => ({
            robot_name: r.robot_name,
            channel: r.channel,
            game_id: r.game_id
        }));
    const createRobots = serverRobots
        .filter(r => !r.game_id || !r.isUpdate)
        .map(r => ({
            robot_name: r.robot_name,
            channel: r.channel,
            default_lang: r.default_lang,
            game_id: r.game_id || undefined
        }));

    try {
        if (updateRobots.length) {
            await ajax.post(URLs.UPDATE_ROBO, { robot_conf_array: JSON.stringify(updateRobots) });
        }
        if (createRobots.length) {
            await ajax.post(URLs.CREATE_ROBO, { robot_conf_array: JSON.stringify(createRobots) });
        }
        Message.success({
            title: "成功",
            message: "操作成功"
        });
    } catch (err) {
        console.error(err);
    }
}

export async function getRobots(businessId) {
    let ret = null;
    try {
        const resp = await ajax.get(URLs.GET_ROBOT, {});
        const { games = [] } = resp.tenants[0].businesses.find(item => item.business_id === businessId);
        ret = games.map(g => ({
            gameId: g.game_id,
            defaultLang: g.default_lang,
            robotName: g.game_name,
            source: JSON.parse(g.answer_channel)
        }));
    } catch (err) {
        console.error(err);
    }
    return ret;
}
